import { UserRolesDataForm } from "./user-roles-data-form";
import { OrganizationDataForm } from "./organization-data-form";

export class UserDetailsDataForm {
	userDetailsId: number;
	firstName: string
	lastName: string;
	userName: string;
	password: string;
	mobileNo: string;
	userRole: string;
	designation: string;
	organizationDetails: OrganizationDataForm;

	createTimestamp: Date;
	updateTimestamp: Date;
	createdBy: number;
	updatedBy: number;
	isDeleted: number;
	isDeactivate: number;
	userRolesDataForm: UserRolesDataForm;
	nda: number;
	reCaptchaToken: string;

	userToken: string;
	msgCode: number;
	message: string;

	constructor() {

	}
}
